"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MixpanelHandler {
    trackEvent(eventName, eventProps) {
        //@ts-ignore
        window.mixpanel.track(eventName, eventProps);
    }
}
exports.default = MixpanelHandler;
